// extracted by mini-css-extract-plugin
export default {"bottom":"DisplayDate_bottom__CkI9L","calendar":"DisplayDate_calendar__UlJ2G","date":"DisplayDate_date__7mSdj"};